export default __webpack_public_path__ + "static/media/c002-whatsapp-02.40945ed4.png";